<template>
  <div class="w-full p-0" :class="topClasses">
    <portal v-if='hasSelectedGridItem' to="above-renderer">
      <placement-grid :render-tools='renderTools' @world-click='onWorldClick' />
    </portal>

    <div class="w-full flex flex-col overflow-x-hidden overflow-y-visible pb-24">
      <div v-show='selectPack' class="w-full flex-none flex flex-row">
        <apollo-query :query='listPacksQuery'
                      :class='selectPack ? "" : "pack-selected"'
                      fetch-policy='cache-and-network'
                      :tag='undefined'
                      class='w-full'
                      :variables='{nextToken:"",size:100}'>
          <template v-slot='{ result: { loading, error, data }, isLoading }'>
            <loader v-if='loading && !data' class="w-full h-24" />
            <!--
            <button class="instant-pack-button"
                    :class='selectedPackButtonClasses({id:"upload"})'
                    @click='onSelectPack({id:"upload",name:"upload",items:[]})'
                    >
              <upload :size='32' />
              Upload Image
            </button>
            -->


            <div class="instant-packs-view-grid w-full">
              <button class="instant-pack-button"
                      v-for='pack in (((data||{}).getPacks||{}).items||[])'
                      :key='pack.name'
                      :class='selectedPackButtonClasses(pack)'
                      @click='onSelectPack(pack)'>

                <img class="overflow-hidden object-contain w-full" :src='makeUrl(pack.thumbnailImage)' loading="lazy" :class='!selectPack ? "h-12" : "h-24"' />

                <div class="text-sm font-thin mx-auto tracking-tight self-center text-white text-wrap pack-text-shadow">{{pack.name}}</div>

              </button>
            </div>

          </template>

        </apollo-query>

      </div>
      <div v-if='!selectPack'
               class='grow overflow-x-hidden overflow-y-hidden pb-24'
              :key='selectedPack.id'>

        <div class="flex flex-row flex-none h-20 selected-pack">
          <div class="h-full">
            <button class="pbc-toggle-button-outlined text-white" @click='back'>
              <chevron-left :size='32' />
              Back
            </button>
          </div>

          <button class="instant-pack-button"
                  :class='selectedPackButtonClasses(selectedPack)'
                  @click='back'>

            <img class="overflow-hidden object-contain w-full" :src='makeUrl(selectedPack.thumbnailImage)' loading="lazy" :class='!selectPack ? "h-12" : "h-24"' />

            <div class="text-sm font-thin mx-auto tracking-tight self-center text-white text-wrap pack-text-shadow">{{selectedPack.name}}</div>

          </button>
        </div>

        <image-uploader v-if='selectedPack.id === "upload"'
                        class="w-full"
                        game-id='gameId'
                        @uploaded='onUpload'
                        :is-short-mode='true'
                        :already-uploaded='uploadedImages'
                        @select='onSelectUploadedImage'
                        />

        <template v-for='({layer,toysheet},i) in allToysheets'>

          <instant-view-toys ref='instantViewToys'
                            :toys='toysheet.toys'
                            class="mb-4"
                            classes='p-2 grid grid-cols-2 gap-2'
                            :key='"toy"+i'
                            @select='onSelectToy(layer, toysheet, $event)'>
            <template #toy='{toy}'>
              <div class="absolute left-0 top-0 flex select-none" :class='toysBlocked[toy.id] ? "text-yellow-300" : ""' >
                <star :size='16'  />
                <span class="text-black text-xs" :class='toysBlocked[toy.id] ? "text-yellow-300" : ""'>{{toy.name}}</span>

              </div>
            </template>
          </instant-view-toys>

          <instant-view-images ref='instantViewSprites'
                                :images='toysheet.sprites' 
                                class="mx-0"
                                :key='"image"+i'
                                @select='onSelectImage(layer, toysheet, $event.image)'
                                    />

          <template v-for='{spritesheet} in toysheet.spritesheets'>
            <instant-view-spritesheet ref='instantViewSpritesheet' :spritesheet='spritesheet.id'
                                      @select='onSelectSprite(layer, toysheet, spritesheet, $event.image)'
                                      :key='spritesheet.id'
                                      :type='makeSpritesheetViewType(selectedPack, toysheet, spritesheet)'
                                      />

          </template>

        </template>

      </div>

    </div>
  </div>
</template>
<script>
import ChevronLeft from '@icons/ChevronLeft.vue';
import Upload from '@icons/Upload.vue';
import ImageUploader from '@ui/molecules/ImageUploader.vue';
import Star from '@icons/Star.vue';
import { flatten, cloneDeep, range } from 'lodash';
import PlacementGrid from '@ui/molecules/PlacementGrid.vue';
import { listPacksQuery } from '@/gql/Queries.js';
import { ApolloQuery } from 'vue-apollo';
import Check from '@icons/Check.vue';
import InstantViewSpritesheet from '@/ui/molecules/InstantViewSpritesheet.vue';
import InstantViewImages from '@/ui/molecules/InstantViewImages.vue';
import InstantViewToys from '@/ui/organisms/InstantViewToys.vue';

const tmpToysBlocked = {};
export default {
  inject:['api'],
  props:{
    partutil: {
      type: Object,
      default() {
        return {
          gamedata:{
            gamedata:{
              uploadedImages:[]
            }
          }
        }
      }
    },
    grid: {
      type: Boolean,
      default: false
    },
    selectedLayers: {
      type: Object,
      default() {
        return {
        }
      }
    },
    direction: {
      type: String,
      default: 'vertical'
    }
  },
  mounted() {
    this.$emit('mode', 'choosepack');
  },
  methods: {
    selectedPackButtonClasses(pack) {
                      //:class='selectPack ? "" : "pack-selected"'
                    //:class='isSelected(pack) ? "pbc-instant-button" : ""'
      const classes = [];
      if (this.isSelected(pack)) {
        classes.push('pbc-toggle-button-outlined pbc-toggle-button-outlined-on');
      }
      if (!this.selectPack) {
        classes.push('pack-selected');
      }
      return classes;
    },
    makeSpritesheetViewType(pack, toysheet, spritesheet) {
      return pack.name.toLowerCase().indexOf("meme") !== -1 ? "big" : "small"
    },
    onUpload(data) {
      console.log('uploaded', data);
      this.uploadedImages.push(data);
    },
    onSelectUploadedImage(data) {
      console.log('data', data);
      this.$emit('select-uploaded-image', data);
    },
    reset() {
      this.back();
    },
    back() {
      this.selectedPack = this.emptyPack;
      this.selectedImage = {};
      this.selectedToy = {};
      this.$emit("mode", "choosepack");
    },
    makeUrl(thumbnailImage) {
      if (!thumbnailImage) {
        return this.api.makeSpritesheetUrlEditor('placeholder.png');
      }
      return this.api.makeSpritesheetUrlEditor(thumbnailImage);
    },
    onSelectPack(pack) {
      this.selectedPack = pack;
      this.$emit("mode", "chosepack");

      this.$ana.track({
        eventCategory: 'pack',
        eventAction: pack.name
      });
    },
    onWorldClick({x,y}) {
      if (this.selectedImage.image) {
        this.instantSelectImage({
          image:this.selectedImage.image,
          spritesheet:this.selectedImage.spritesheet,
          position:{x,y},
          layer:this.selectedImage.layer,
          toysheet:this.selectedImage.toysheet

        });

        if (true || !this.selectedImage.spritesheet) {
          // TODO: hackyhack
          this.selectedImage = {};
          (this.$refs.instantChooseSprites||[]).forEach( (ivs) => {
            ivs.deselect();
          });
          (this.$refs.instantViewSpritesheet||[]).forEach( (ivs) => {
            ivs.deselect();
          });

        }
      } else if (this.selectedToy.toy) {
        this.instantSelectToy({
          layer:this.selectedToy.layer,
          toysheet:this.selectedToy.toysheet,
          toy:this.selectedToy.toy,
          position:{x,y}
        });
        this.selectedImage = {};
        this.selectedToy = {};
        (this.$refs.instantChooseSprites||[]).forEach( (ivs) => {
          ivs.deselect();
        });
        (this.$refs.instantViewSpritesheet||[]).forEach( (ivs) => {
          ivs.deselect();
        });
      }

    },
    onSelectToy(layer, toysheet, toy) {
      console.log('on select toy', layer, toysheet, toy);

      if (this.toysBlocked[toy.id]) {
        (this.$refs.instantViewToys||[]).forEach( (ivs) => {
          ivs.deselect();
        });
        return;
      }

      this.selectedToy = {
        layer,
        toysheet,
        toy
      }
      this.selectedImage = {};
      (this.$refs.instantViewSpritesheet||[]).forEach( (ivs) => {
        ivs.deselect();
      });
      (this.$refs.instantChooseSprites||[]).forEach( (ivs) => {
        ivs.deselect();
      });
      this.$emit("mode", "placing");

      this.$ana.track({
        eventCategory: 'packToy',
        eventAction: toy.id
      });
      this.onWorldClick({x:0,y:0})

    },
    onSelectImage(layer, toysheet, image) {
      this.selectedImage = {
        image,
        toysheet
      };
      (this.$refs.instantViewToys||[]).forEach( (ivt) => {
        ivt.deselect();
      });
      (this.$refs.instantViewSpritesheet||[]).forEach( (ivs) => {
        ivs.deselect();
      });
      this.$emit("mode", "placing");

      const chosenImage = image.id;
      this.$ana.track({
        eventCategory: 'packImage',
        eventAction: chosenImage
      });
      this.onWorldClick({x:0,y:0})
    },
    onSelectSprite(layer, toysheet, spritesheet, image) {

      this.selectedImage = {
        image,
        spritesheet,
        layer,
        toysheet
      }
      this.selectedToy = {};
      (this.$refs.instantViewToys||[]).forEach( (ivt) => {
        ivt.deselect();
      });
      (this.$refs.instantViewSprites||[]).forEach( (ivt) => {
        ivt.deselect();
      });
      this.$emit("mode", "placing");

      const chosenImage = image.name;
      this.$ana.track({
        eventCategory: 'packSprite',
        eventAction: chosenImage
      });

      this.onWorldClick({x:0,y:0})

    },
    instantSelectImage({layer,toysheet,image,spritesheet,position}) {
      this.$emit('select-image', {
        layer,
        toysheet,
        image,
        spritesheet,
        position
      });
    },
    async instantSelectToy({layer,toysheet,toy,position}) {
      this.$emit('select-toy', {
        layer,
        toysheet,
        toy,
        position
      });
      (this.$refs.instantViewToys||[]).forEach( (ivt) => {
        ivt.deselect();
      });

      this.$emit("mode", "chosepack");
    },
    isSelected(pack) {
      if (this.selectedPack.id === pack.id) {
        return true;
      } else {
        return false;
      }
    },
    filterPacks(packs) {
      return packs.filter( (pack) => {
        return pack.items.filter( ({layer}) => {
        //return pack.layers.filter( (layer) => {
          return Object.keys(this.selectedLayers).length === 0 ? true : this.selectedLayers[layer.id];
        }).length;
      });
    }
  },
  data() {
    const gamedata = this.partutil.gamedata.gamedata;
    if (typeof(gamedata.uploadedImages) === 'undefined') {
      this.$set(gamedata, 'uploadedImages', []);
    }
    const uploadedImages = gamedata.uploadedImages;
    return {
      listPacksQuery,
      selectedImage:{},
      selectedToy:{},
      toysBlocked:tmpToysBlocked,
      toyLimits:{},
      uploadedImages
    }
  },
  components: {
    ApolloQuery,
    PlacementGrid,
    InstantViewSpritesheet,
    InstantViewImages,
    InstantViewToys,
    Star,
    //Upload,
    ImageUploader,
    ChevronLeft
  },
  computed:{
    emptyPack() {
      return this.$store.state.emptyPack;
    },
    selectedPack:{
      get() {
        return this.$store.state.selectedPack;
      },
      set(nv) {
        this.$store.commit('setSelectedPack', nv);
      }
    },
    topClasses() {
      const classes = [];
      if (!this.grid) {
        classes.push('h-32');
      } else {
      }
      if (this.direction === 'vertical') {
        classes.push('instant-choose-pack-vertical');
      } else {
        classes.push('instant-choose-pack-horizontal');
      }
      return classes;
    },
    hasSelectedGridItem() {
      return !!this.selectedImage.image || !!this.selectedToy.toy;
    },
    allToysheets() {
      return flatten(((this.selectedPack||{}).items||[]).map( ({toysheets,layer}) => {
        return toysheets.map( (inToysheet) => {
          const toysheet = cloneDeep(inToysheet);
          toysheet.toys = toysheet.toys.map( ({limit,toy}) => {
            let disabled = false;
            return {toy,disabled};
          });
          return {layer,toysheet}
        });
      }));
    },
    selectPack() {
      return !this.selectedPack || this.selectedPack === this.emptyPack || this.selectedPack.id === 'empty';
    }
  },
  watch:{
    hasSelectedGridItem(nv) {
      if (nv) {
        this.$emit('hide-for-placing');
      }
    },
    selectedPack: {
      immediate:true,
      handler(nv) {
        if (!nv || nv === this.emptyPack || (nv||{}).id === 'empty') {
          return;
        }
        ((this.selectedPack||{}).items||[]).forEach( (item) => {
          item.toysheets.forEach( (toysheet) => {
            toysheet.toys.forEach( ({limit,toy}) => {
              this.toyLimits[toy.id] = limit;
            });
          });
        })
      }

    }
  }
}
</script>
<style>
.pack-text-shadow {
  text-shadow: 0 2px 4px rgba(0,0,0,1.0);
}
.dropzone {
  padding: 0px !important;
  margin: 0px !important;
  height: auto !important;
  min-height: auto !important;
}
.dz-message {
  padding: 0px !important;
  margin: 0px !important;
}
.selected-pack .pbc-toggle-button-outlined {
  @apply h-20 px-2 my-4;
}
.selected-pack .pbc-toggle-button-outlined-on {
  @apply bg-blue-700 text-white border-black w-full;
}
.selected-pack .pbc-toggle-button-outlined-off {
  @apply bg-gray-800 text-white border-black;
}

</style>

